import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { IsfShortModel } from '@data-layer/models/isf';

@Component({
  selector: 'isf-batch-items',
  templateUrl: './isf-batch-items.component.html',
  styleUrls: ['./isf-batch-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IsfBatchItemsComponent {
  @Input() public checkedItemIds: number[] = [];
  @Input() public isfItems: IsfShortModel[] = [];
  @Output() public isCheckedChange: EventEmitter<{ id: number; checked: boolean }> = new EventEmitter<{ id: number; checked: boolean }>();
  @Output() public isCheckedAllChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public review: EventEmitter<number> = new EventEmitter<number>();

  constructor(private cdr: ChangeDetectorRef) {}

  public markDataForCheck(): void {
    this.cdr.markForCheck();
  }

  public isChecked(id: number): boolean {
    return this.checkedItemIds.includes(id);
  }

  public isCheckedNext(index: number): boolean {
    if (index >= this.isfItems.length) {
      return false;
    }

    return this.checkedItemIds.includes(this.isfItems?.[index + 1]?.id);
  }

  public get isAllChecked(): boolean {
    if (!this.isfItems.length) {
      return false;
    }

    return this.checkedItemIds.length === this.isfItems.filter((item: IsfShortModel) => item.valid).length;
  }

  public get isAllInvalid(): boolean {
    if (!this.isfItems.length) {
      return false;
    }

    return this.isfItems.every((item: IsfShortModel) => !item.valid);
  }
}
